import { render, staticRenderFns } from "./Platform-Icon.vue?vue&type=template&id=0f0990b2&scoped=true&lang=pug"
import script from "./Platform-Icon.vue?vue&type=script&lang=ts"
export * from "./Platform-Icon.vue?vue&type=script&lang=ts"
import style0 from "./Platform-Icon.vue?vue&type=style&index=0&id=0f0990b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0990b2",
  null
  
)

export default component.exports